import request from '@/utils/request'
// 获取首页轮播
export function getImg(labelId,languageId){
    return request({
        url:'/resources/query',
        methods: 'get',
        params :{ labelId,languageId }
    })
}

// 获取首页生态合作网络
export function getInternet(labelId,languageId){
    return request({
        url:'/country/mesh/query',
        methods: 'get',
        params :{ labelId,languageId }
    })
}
// 获取语言
export function getLanguage() {
  return request({
    url: '/language/query',
    method: 'get',
  })
}

// 查询文章列表、分页查询
export function getList(pageNum,pageSize,labelId,languageId,title) {
  return request({
    url: '/article/query',
    method: 'get',
    params:{ 
      pageNum:pageNum,
      pageSize:pageSize,
      labelId:labelId ,
      languageId:languageId,
      title:title
    }
  })
}
// 查询图片列表、分页查询
export function getList1(pageNum,pageSize,labelId,languageId) {
  return request({
    url: '/resources/query/page',
    method: 'get',
    params:{ 
      pageNum:pageNum,
      pageSize:pageSize,
      labelId:labelId ,
      languageId:languageId,
    }
  })
}

// 通过文章id 获取详情
export function imgDetail(id) {
    return request({
      url: `/resources/query/${id}`,
      method: 'get'
    })
}
// 通过文章id 获取详情
export function artDetail(id) {
    return request({
      url: `/article/query/${id}`,
      method: 'get'
    })
}

// 菜单详情描述
export function lableRoute(id) {
  return request({
      url: `/label/query/?languageId=${id}`,
      method: 'get'
  })
}

// 菜单详情描述
export function lableDetail(id) {
    return request({
      url: `/label/query/${id}`,
      method: 'get'
    })
  }

// 查询构建生态网络列表
export function getCountry(languageId) {
    return request({
      url: 'country/mesh/query',
      method: 'get',
      params: { languageId }
    })
}

// 查询世界国家名称列表
export function getstate(languageId) {
  return request({
    url: 'country/query',
    method: 'get',
    params: { languageId }
  })
}

// 提交留言
export function getleave(data) {
  return request({
    url: '/comment/save',
    method: 'post',
    data
  })
}
// 查询促进会概括
export function getPromotion(labelId,languageId) {
  return request({
    url: '/about_us/query',
    method: 'get',
    params: { 
      labelId:labelId,
      languageId:languageId 
    }
  })
}
// 查询阅读推荐
export function getRead(labelId,languageId,pageNum,pageSize) {
  return request({
    url: '/article/recommond',
    method: 'get',
    params: { 
      labelId:labelId,
      languageId:languageId,
      pageNum:pageNum,
      pageSize:pageSize
    }
  })
}










// WEBPACK FOOTER //
// ./src/api/user.js